import { Component } from '@angular/core';

@Component({
  selector: 'fgb-photo-scramble-layout-page',
  templateUrl: './photo-scramble-layout-page.component.html',
  styleUrl: './photo-scramble-layout-page.component.scss',
})
export class PhotoScrambleLayoutPageComponent {}
